import React,{useState,useEffect} from 'react'
import Container from 'olive-react-myoneui/lib/Container';
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import DropdownFlagsPlain from './DropdownFlagsPlain';
import { useSearchParams } from 'react-router-dom';
import { envelopeIcon, headerPhoneIcon, externalLink, externalLinkIcon, twitterIcon, facebookLogoIcon, instaLogoIcon, whatsAppLogoIcon, telegramLogoIcon, youTubeLogoIcon, linkedInLogoIcon, closeIcon, unsubcribedMessageIcon } from '../constants/icons';
import { useSelector } from 'react-redux';
import { API_URL, commonModuleName } from "../constants/config";
import { useTranslation } from 'react-i18next';
import { fetchAnalytics } from '../api/analytics';
import { Helmet } from 'react-helmet';
import { getAnalyticsCode, parseScriptTags } from '../helpers/seo_helper';

function TopHeader({ className }) {
  const { t } = useTranslation(commonModuleName);
  const website = useSelector((state) => state.user.website);
  const miscellaneous = useSelector((state) => state.user.miscellaneous);
  const isLoggedIn = useSelector((state) => state.user.user.is_logged_in);
  const email_verified = useSelector((state) => state.user.user.logged_in_user.user.us_email_verified);
  const [searchParams, setSearchParams] = useSearchParams();
  const informationBars = useSelector((state) => state.user.headerMenus?.information_bars ? state.user.headerMenus.information_bars : []);
  const [verify,setVerify]                            = useState(true);
  const [currentPopupIndex, setCurrentPopupIndex] = useState(() => {
    const savedIndex = localStorage.getItem('currentPopupIndex');
    return savedIndex ? parseInt(savedIndex, 10) : 0;
  });  
  const [analytics, setAnalytics] = useState('');

  const popUpMessages = informationBars
    .filter((elem) => elem?.n_notification_bar_type === '2')
    .map((elem, index) => ({
      content: elem?.n_content || '',
      backgroundColor: elem.n_background_color || '#ffffff',
      textColor: elem.n_text_color || '#000000',
      index,
    }));

    const [notificationBarShow, setNotificationBarShow] = useState(
      popUpMessages.length > 0 &&
      (localStorage.notification
        ? new Date().getTime() > parseInt(localStorage.notification) + 86400000
        : true)
    );

    const [messagenotificationBarShow, setMessagenotificationBarShow] = useState(
      localStorage.messagenotification
        ? new Date().getTime() > parseInt(localStorage.messagenotification) + 3600000
        : true
    );

  const notificationBarClose = () => {
    if (currentPopupIndex < popUpMessages.length - 1) {
      const nextIndex = currentPopupIndex + 1;
      setCurrentPopupIndex(nextIndex);
      localStorage.setItem('currentPopupIndex', nextIndex);
    } else {
      localStorage.setItem('currentPopupIndex', 0);
      localStorage.setItem('notification', new Date().getTime());
      setCurrentPopupIndex(0);
      setNotificationBarShow(false);
    }
  };

  useEffect(() => {
    if (
      popUpMessages.length > 0 &&
      (localStorage.notification
        ? new Date().getTime() > parseInt(localStorage.notification, 10) + 86400000
        : true)
    ) {
      setNotificationBarShow(true);
    }
  }, [currentPopupIndex]);

  const createMarkup = async () => {
    if (document.getElementById("custom_script").innerHTML != "") return false;
    let response;
    response = await fetch(`${API_URL}assets/pseudo_files/custom_script.js`)
    const backendHtmlString = await response.text();
    return backendHtmlString;
  }
  createMarkup().then(result => {
    if (result === false) return false;
    document.getElementById("custom_script").innerHTML = result;
    loadScript();
  });

  const loadScript = () => {
    const dynamicScripts = document.querySelectorAll("#custom_script script");
    dynamicScripts.forEach((elem) => {
      let script = document.createElement('script');
      const script_src = elem.getAttribute("src")
      if (script_src != null && script_src != '') {
        script.src = script_src;
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        }
      }
      script.innerHTML = elem.innerHTML;
      script.async = false;
      document.body.appendChild(script);
      return () => {
          document.body.removeChild(script);
      }
    });
    return false;
  }

  const verifyMail = () => {
    const host = window.location.hostname
    let url = `https://${host}/api/sendVerificationMail`
    let apiRes =  fetch(url);
    setVerify(false);
  }

  const messagenotificationBarClose = () => {
    setMessagenotificationBarShow(false);
    localStorage.setItem('messagenotification', new Date().getTime());
  }

  useEffect(() => {
    const analyticsData = async () => {
      const analytics = await fetchAnalytics(miscellaneous.account_id);
      setAnalytics(analytics);
    };
    analyticsData();
  }, []);

  // console.log(email_verified,"email_verified")
  return (
    <>
    <Helmet>
      {getAnalyticsCode(analytics, "header").map(({ name, code }) => {
          const scriptBlocks = parseScriptTags(code);
          return scriptBlocks.map((script, idx) => {
            return(
              <script key={`${name}-${idx}`} {...script.props}>
                {script.content}
              </script>
            )
          })
      })}
    </Helmet>
    {messagenotificationBarShow && email_verified == 0 ? 
      <Container fluid id="notificationBar" className="top-notification-bar">
        <Row>
          <Col sm={12} className="text-center p-2 position-relative d-flex align-items-center justify-content-center custom-gap">
            <span className="message-icon">{unsubcribedMessageIcon}</span>
            {/* <div dangerouslySetInnerHTML={{__html: popUpMessage}} /> */}
            {verify ?
            <div>It seems your mail id is not verified. <a href="javascript:void(0)" id="verify_user" onClick={verifyMail}>Verify Now</a></div>
            : <div>The verification email has been sent.Check your inbox and verify.​</div>}
            <div className="cross-btn-wrap">
           <span className="close" onClick={messagenotificationBarClose}>
              <svg xmlns="http://www.w3.org/2000/svg" width="7.775" heunsubcribedMessageIconight="7.775" viewBox="0 0 7.775 7.775">
                <g id="Group_18235" data-name="Group 18235" transform="translate(-2.409 -8.639)">
                  <g id="Group_20988" data-name="Group 20988" transform="translate(3.399 9.629)">
                    <path id="Path_21521" data-name="Path 21521" d="M5035.352,5196.5l5.794,5.795" transform="translate(-5035.352 -5196.5)" fill="#5a5d5d" stroke="#5b5d5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"/>
                    <path id="Path_21522" data-name="Path 21522" d="M5041.146,5196.5l-5.794,5.795" transform="translate(-5035.352 -5196.5)" fill="#5a5d5d" stroke="#5b5d5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"/>
                  </g>
                </g>
              </svg>
            </span>
            </div>
          </Col>
        </Row>
      </Container> : ""
    }

    {notificationBarShow && popUpMessages.length > 0 && (
        <Container
          fluid
          id={`notificationBar_${currentPopupIndex}`}
          className="top-notification-bar"
          style={{ backgroundColor: popUpMessages[currentPopupIndex].backgroundColor }}
        >
          <Row>
            <Col
              sm={12}
              className="text-center p-2 position-relative d-flex align-items-center justify-content-center custom-gap"
              style={{ color: popUpMessages[currentPopupIndex].textColor }}
            >
              <div dangerouslySetInnerHTML={{ __html: popUpMessages[currentPopupIndex].content }} />
              <div className="cross-btn-wrap">
              <span
                  className="close"
                  onClick={notificationBarClose}
                  style={{color: popUpMessages[currentPopupIndex].textColor}}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="7.775" height="7.775" viewBox="0 0 7.775 7.775">
                    <g id="Group_18235" data-name="Group 18235" transform="translate(-2.409 -8.639)">
                      <g id="Group_20988" data-name="Group 20988" transform="translate(3.399 9.629)">
                        <path
                          id="Path_21521"
                          data-name="Path 21521"
                          d="M5035.352,5196.5l5.794,5.795"
                          transform="translate(-5035.352 -5196.5)"
                          fill="#5a5d5d"
                          stroke={popUpMessages[currentPopupIndex].textColor}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.4"
                        />
                        <path
                          id="Path_21522"
                          data-name="Path_21522"
                          d="M5041.146,5196.5l-5.794,5.795"
                          transform="translate(-5035.352 -5196.5)"
                          fill="#5a5d5d"
                          stroke={popUpMessages[currentPopupIndex].textColor}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.4"
                        />
                      </g>
                    </g>
                  </svg>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      )}
      <div className={`${className || ''} top-header-wrapper` + (searchParams.get('privacy') === "" ? " d-none" : "")}>
        <Container fluid className="ps-0">
          <Row>
            <Col sm={10} className="d-flex align-items-center mk-gap-28px">
              {
                website.email_id_visible == 1 && website.site_email != "" && (
                  <a href={"mailto:" + website.site_email} className="text-icon gap-2 p-0 bg-transparent btn btn-text-icon" target="_blank">
                    {envelopeIcon}
                    {website.site_email}
                  </a>
                )
              }
              {
                website.contact_number_visible == 1 && website.site_phone != "" &&
                <>
                  {website.email_id_visible == 1 && website.site_email != "" && <div className="ui-nav-divider"></div>}
                  <a href={"tel:" + website.site_phone} className="text-icon gap-2 p-0 bg-transparent btn btn-text-icon" target="_blank">
                    {headerPhoneIcon}
                    {website.site_phone}
                  </a>
                </>
                
              }
              {
                isLoggedIn && 
                <>
                  {((website.email_id_visible == 1 && website.site_email != "") || (website.contact_number_visible == 1 && website.site_phone != "")) && <div className="ui-nav-divider"></div>}
                  <a href="/student-dashboard" target="_blank" className="btn-explore text-icon gap-2 py-2 bg-transparent btn btn-text-icon">
                    {t('go_to_my_subscriptions')}
                    {externalLink}
                  </a>
                </>
              }
            </Col>
            <Col sm={2} className="d-flex align-items-center mk-gap-28px justify-content-end">
              <ul className="navbar-nav navbar-icons mb-lg-0 d-flex flex-row">
                {
                  website.whatsapp_visible && website.whatsapp_visible == 1 &&
                  (<li className="nav-item m-0">
                    <a className="nav-link" aria-current="page" target="_blank" href={"https://api.whatsapp.com/send?phone=" + (website.site_whatsapp_number && website.site_whatsapp_number != "" ? website.site_whatsapp_number : "")}>
                      {whatsAppLogoIcon}
                    </a>
                  </li>)
                }
                {
                  website.facebook_visible && website.facebook_visible == 1 &&
                  (<li className="nav-item m-0">
                    <a className="nav-link" aria-current="page" target="_blank" href={(website.facebook_link && (website.facebook_link != "" && website.facebook_link != "https://")) ? website.facebook_link : "https://facebook.com"}>
                      {facebookLogoIcon}
                    </a>
                  </li>)
                }
                {
                  website.twitter_visible && website.twitter_visible == 1 &&
                  (<li className="nav-item m-0">
                    <a className="nav-link" aria-current="page" target="_blank" href={(website.twitter_link && (website.twitter_link != "" && website.twitter_link != "https://")) ? website.twitter_link : "https://twitter.com"}>
                      {twitterIcon}
                    </a>
                  </li>)
                }
                {
                  website.instagram_visible && website.instagram_visible == 1 &&
                  (<li className="nav-item m-0">
                    <a className="nav-link" target="_blank" href={(website.instagram_link && (website.instagram_link != "" && website.instagram_link != "https://")) ? website.instagram_link : "https://instagram.com"}>
                      {instaLogoIcon}
                    </a>
                  </li>)
                }
                {
                  website.telegram_visible && website.telegram_visible == 1 &&
                  (<li className="nav-item m-0">
                    <a className="nav-link" target="_blank" href={(website.telegram_link && (website.telegram_link != "" && website.telegram_link != "https://")) ? website.telegram_link : "https://telegram.com"}>
                      {telegramLogoIcon}
                    </a>
                  </li>)
                }
                {
                  website.youtube_visible && website.youtube_visible == 1 &&
                  (<li className="nav-item m-0">
                    <a className="nav-link" target="_blank" href={(website.youtube_link && (website.youtube_link != "" && website.youtube_link != "https://")) ? website.youtube_link : "https://youtube.com"}>
                      {youTubeLogoIcon}
                    </a>
                  </li>)
                }
                {
                  website.linkedin_visible && website.linkedin_visible == 1 &&
                  (<li className="nav-item m-0">
                    <a className="nav-link" target="_blank" href={(website.linkedin_link && (website.linkedin_link != "" && website.linkedin_link != "https://")) ? website.linkedin_link : "https://linkedin.com"}>
                      {linkedInLogoIcon}
                    </a>
                  </li>)
                }
              </ul>
              {website.whatsapp_visible == 1 || website.facebook_visible == 1 || website.twitter_visible == 1 || website.instagram_visible == 1 || website.telegram_visible == 1 || website.youtube_visible == 1 || website.linkedin_visible == 1 ? (
                <div className="ui-nav-divider"></div>
              ) : null}
              <DropdownFlagsPlain />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default TopHeader;
